import { notificationsApi } from '../api/notifications.js';
import { workspaceApi } from '../api/workspace.js';
import { searchApi } from '../api/search.js';

export function navBarComponent() {
  return {
    unreadCount: 0,
    notifications: [],
    workspaceName: '',
    _pollTimer: null,

    async init() {
      if (!window.Alpine?.store('auth')?.currentWorkspaceId) return;
      await Promise.all([this.fetchUnreadCount(), this.fetchWorkspaceName()]);
      this._pollTimer = setInterval(() => this.fetchUnreadCount(), 60000);
    },

    async fetchUnreadCount() {
      try {
        const { data } = await notificationsApi.unread();
        this.unreadCount = data.meta?.unread_count ?? 0;
        this.notifications = data.data ?? [];
      } catch {}
    },

    async fetchWorkspaceName() {
      try {
        const { data } = await workspaceApi.get();
        this.workspaceName = data.data?.name ?? '';
      } catch {}
    },

    async loadNotifications() {
      await this.fetchUnreadCount();
    },

    async markRead(n) {
      if (n.status !== 'unread') return;
      try {
        await notificationsApi.markRead(n.id);
        n.status = 'read';
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      } catch {}
    },

    notificationUrl(n) {
      const p = n.payload ?? {};
      if (p.contact_id) return `#/contacts/${p.contact_id}`;
      if (p.lead_id)    return `#/leads`;
      if (p.asset_id)   return `#/assets/${p.asset_id}`;
      if (p.task_id)    return `#/tasks`;
      if (p.access_id)  return `#/accesses`;
      const type = n.type ?? '';
      if (type.startsWith('contact.')) return '#/contacts';
      if (type.startsWith('lead.'))    return '#/leads';
      if (type.startsWith('access.'))  return '#/accesses';
      if (type.startsWith('task.'))    return '#/tasks';
      return '#/notifications';
    },

    async openNotification(n, closeDropdown) {
      await this.markRead(n);
      closeDropdown();
      const url = this.notificationUrl(n);
      window.location.hash = url.replace(/^#/, '');
    },

    async markAllRead() {
      try {
        const auth = window.Alpine.store('auth');
        await fetch('/api/v1/notifications/read-all', {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${auth.accessToken}`,
            'X-Workspace-Id': auth.currentWorkspaceId,
          },
        });
        this.notifications.forEach(n => n.status = 'read');
        this.unreadCount = 0;
      } catch {}
    },

    toggleLocale() {
      const i18n = window.Alpine.store('i18n');
      i18n.setLocale(i18n.locale === 'fa' ? 'en' : 'fa');
    },
  };
}

export function globalSearchComponent() {
  return {
    query: '',
    results: { contacts: [], companies: [], leads: [] },
    loading: false,
    _timer: null,

    close() {
      window.Alpine.store('search').open = false;
      this.query = '';
      this.results = { contacts: [], companies: [], leads: [] };
      this.loading = false;
      clearTimeout(this._timer);
    },

    get hasResults() {
      return this.results.contacts.length > 0 || this.results.companies.length > 0 || this.results.leads.length > 0;
    },

    get showEmpty() {
      return !this.loading && this.query.length >= 2 && !this.hasResults;
    },

    get showHint() {
      return !this.loading && this.query.length < 2;
    },

    onInput() {
      clearTimeout(this._timer);
      if (this.query.length < 2) {
        this.results = { contacts: [], companies: [], leads: [] };
        return;
      }
      this._timer = setTimeout(() => this.doSearch(), 300);
    },

    async doSearch() {
      this.loading = true;
      try {
        const { data } = await searchApi.global(this.query);
        this.results = data.data;
      } catch {
        this.results = { contacts: [], companies: [], leads: [] };
      } finally {
        this.loading = false;
      }
    },

    navigate(path) {
      window.location.hash = path;
      this.close();
    },
  };
}
